import type { FC } from 'react';
import styles from './PanelHeader.module.css';
import type { PanelHeaderProps } from './PanelHeader.types';

export const PanelHeader: FC<PanelHeaderProps> = ({ children }) => {
  return <nav className={styles.panelHeader}>{children}</nav>;
};
